const { isEmpty } = require('lodash');

class UserPreferenceService {
    constructor($rootScope, restangular, bootstrap, $q) {
        this.$rootScope = $rootScope;
        this.restangular = restangular;
        this.api = restangular.one('UserPreferences');
        this.bootstrap = bootstrap;
        this.$q = $q;
        this.shopperPreferencesKey = bootstrap.bootstrapped.ShopperPreferences;
    }

    getUserPreference() {
        const shopperPreferences = this.bootstrap.getBootstrappedDataIfPresent(this.shopperPreferencesKey);

        if (!!shopperPreferences && !isEmpty(shopperPreferences)) {
            return this.$q.when(shopperPreferences);
        }

        return this.api.doGET()
            .then((response) => {
                this.bootstrap.setData(this.shopperPreferencesKey, response);
                return response;
            });
    }

    setListViewLayout(value) {
        this.doPost('SetUserPreferenceListViewLayout', 'ListViewLayout', value);
    }

    setListViewGroupBy(value) {
        this.doPost('SetUserPreferenceListViewGroupBy', 'ListViewGroupBy', value);
    }

    setFulfilmentSelectorStepStartShopping(value) {
        this.doPost('EnableFulfilmentSelectorStepStartShopping', 'FulfilmentSelectorStepStartShoppingEnabled', value);
    }

    setDismissedRegionalNotificationPreference(value) {
        this.doPost('HasDismissedRegionalNotificationPreference', 'HasDismissedRegionalNotification', value);
    }

    setOnboardingPreference(value) {
        this.doPost('HasDoneOnboardingPreference', 'HasDoneOnboarding', value);
    }

    setLastViewFulfilmentMethodSelector(value) {
        this.doPost('SetUserPreferenceLastViewFMS', 'HasSeenFulfilmentSelectorToday', value);
    }

    doPost(endpoint, subKey, value) {
        this.api.one(endpoint)
            .doPOST({ Value: value })
            .then(() =>
                this.bootstrap.setData(this.shopperPreferencesKey, value, subKey));
    }

    setListViewVisited(value) {
        this.doPost('SetUserPreferenceListViewVisited', 'ListViewVisited', value);
    }

    setListViewGroupByVisited(value) {
        this.doPost('SetUserPreferenceListViewGroupByVisited', 'ListViewGroupByVisited', value);
    }

    SetDeliveryPlusCancelledNotificationDisabled(value) {
        this.doPost('SetDeliveryPlusCancelledNotificationDisabled', 'DeliveryPlusCancelledNotificationDisabled', value);
    }
}

UserPreferenceService.$inject = ['$rootScope', 'Restangular', 'BootstrapService', '$q'];

module.exports = UserPreferenceService;



// WEBPACK FOOTER //
// ./src/common/userpreference/user-preference.service.js